export const GRADE_OPTIONS = [
  { value: '2', label: '2nd Grade', subject: 'Math Foundations 1' },
  { value: '3', label: '3rd Grade', subject: 'Math Foundations 2' },
  { value: '4', label: '4th Grade', subject: 'Math Foundations 3' },
  { value: '5', label: '5th Grade', subject: 'Arithmetic Mastery' },
  { value: '6', label: '6th Grade', subject: 'Math Foundations 4' },
  { value: '7', label: '7th Grade', subject: 'Intro to Pre Algebra' },
  { value: '8', label: '8th Grade', subject: 'Pre Algebra' },
  { value: '9', label: '9th Grade', subject: 'Algebra 1' },
  { value: '10', label: '10th Grade', subject: 'Geometry' },
  { value: '11', label: '11th Grade', subject: 'Algebra 2' },
  { value: '12', label: '12th Grade', subject: 'Pre Calculus' },
  { value: 'college', label: 'College', subject: 'Calculus' },
];

export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];